import React, { createContext, useContext, useState } from 'react';

export type Toast = {
  // Support other props from cn-web-ordering Toast as-needed
  message: string;
  title?: string;
};

export type ToastContextProps = {
  closeToast: (toast: Toast) => void;
  toasts: Toast[];
  toast: (toast: Toast) => void;
};

export const ToastContext = createContext<ToastContextProps>({
  toasts: [],
  toast: () => {},
  closeToast: (_toast) => {},
});

export default function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  function makeToast(toast: Toast) {
    setToasts((oldToasts) => [toast, ...oldToasts]);
  }

  function closeToast(toast: Toast) {
    const newToasts = toasts.filter((t) => t.message !== toast.message);
    setToasts(newToasts);
  }

  const contextProps = {
    toasts,
    toast: makeToast,
    closeToast,
  };

  return <ToastContext.Provider value={contextProps}>{children}</ToastContext.Provider>;
}
